/**
 * lib/document/ProductSkus.js:NO_POINT_SKU_NAMES
 */
export const NO_POINT_SKU_NAMES = ['TOM Premium Membership Gift'];
